import { Card, Col, Row, Table } from 'antd';
import React from 'react';
import PrintIcon from '../../../icons/print.svg';
import './find-nds-payer-service.scss';
import { capitalizeFirstLetter, localize } from '/react4xp/mixins/helpers';
import PrintForm2 from '/react4xp/mixins/ui/print-form-2';

const Results = (props: any) => {
    const { data, columns, values, translations } = props;

    let cardTitle = data[`name${capitalizeFirstLetter(props.lang)}`];
    if (!cardTitle) {
        cardTitle = data['nameRu'];
    }

    return (
        <div className="response">
            <Col
                md={24}
                xs={24}
                lg={24}
            >
                <div className="response__title">
                    {localize('print-form.search-results', translations)}
                </div>
            </Col>
            {typeof data.iinBin !== 'undefined' ? (
                <div className="taxpayer">
                    <Col
                        md={12}
                        xs={24}
                        lg={12}
                    >
                        <Card className="card mb-4">
                            <div className="card__title">{cardTitle}</div>
                            <Row>
                                <Col>
                                    <div>{localize('iin-bin', translations)}</div>
                                    <div>{data?.iinBin || localize('no-data', translations)}</div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Table
                        {...props}
                        className={'table-default'}
                        rowKey={(record) => record && record.id}
                        dataSource={[data]}
                        bordered
                        columns={columns}
                        scroll={{ x: 'max-content' }}
                    />
                    <PrintForm2
                        apiUrl={'/services/isnaportalsync/open-api/nds-payer/search-payer-data'}
                        icon={<PrintIcon />}
                        params={values}
                        isPost
                        translations={translations}
                    />
                </div>
            ) : (
                <div className="response__total">
                    {localize('notification.no-data', translations)}
                </div>
            )}
        </div>
    );
};

export default Results;
